exports = module.exports = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".img-cover[data-v-0c577c43]{object-fit:cover;width:158px;height:106px}@media only screen and (max-width: 575px){.img-cover[data-v-0c577c43]{object-fit:cover;width:100%;height:225px}}\n", ""]);

